import MaintenanceWorkflowForwardingDirectiveEntryExecutionEntry from "../../../sections/DirectiveEntry/entries/ExecutionEntry";

const ExecutionEntryOnGoingEstablishmentChoice = () => {
  return (
    <>
      <MaintenanceWorkflowForwardingDirectiveEntryExecutionEntry />
    </>
  );
}

export default ExecutionEntryOnGoingEstablishmentChoice;
